import { defineStore } from 'pinia';

export const useUiStateStore = defineStore('uiState', {
    state: () => ({
        routeLoading: false,
        routeError: false,
        routeErrorMessage: null,
        branding: {
            themes: {
                light: {
                    primaryColor: null,
                    secondaryColor: null,
                },
                dark: {
                    primaryColor: null,
                    secondaryColor: null,
                },
            },
        },
    }),
    actions: {
        setRouteLoading(value) {
            this.routeLoading = value;
            this.routeError = false;
            this.routeErrorMessage = null; //Remove error
        },
        setRouteError(err) {
            this.routeLoading = false; //Stop loading
            this.routeError = true;
            this.routeErrorMessage = err;
        },
    },
});